/** Relative path for backend health on the **viewer** origin (CloudFront routes **`/api/*`** to **Lambda** with **CachingDisabled**). */
export const HEALTH_API_PATH = "/api/v1/health";

/**
 * Issues `GET /api/v1/health` against the current origin.
 *
 * @param init - Optional fetch init (`signal` for `AbortController`).
 */
export function fetchHealth(init?: RequestInit): Promise<Response> {
  const headers = new Headers(init?.headers);
  if (!headers.has("Accept")) {
    headers.set("Accept", "application/json");
  }
  return fetch(HEALTH_API_PATH, {
    ...init,
    method: "GET",
    headers,
  });
}
